import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AttendanceBody } from '../entities/attendance-body';
import { DateUtils } from '../../shared/_utils/services/dateUtils';
import { tap, map,catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class AttendanceBodyService extends BaseCrudService<AttendanceBody> {

  uri = '/api/attendanceBody/';
  extraSearchFields: {clockInReduced?: Date};

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance AttendanceBodyService');
  }

  buildSentence(entity?: AttendanceBody, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.weekNumber ?
          `weekNumber${QueryOperator.Contain}${entity.weekNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.dayNumber ?
          `dayNumber${QueryOperator.Contain}${entity.dayNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockIn && !this.extraSearchFields ?
          // tslint:disable-next-line:max-line-length
          `clockIn${QueryOperator.Between}${DateUtils.resetTime(entity.clockIn).toISOString()}${QueryOperator.Slash}${DateUtils.addDays(entity.clockIn, 1).toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockOut ?
          `clockOut${QueryOperator.Equal}${entity.clockOut.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockInL ?
          `clockInL${QueryOperator.Equal}${entity.clockInL.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockOutL ?
          `clockOutL${QueryOperator.Equal}${entity.clockOutL.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isEdit ?
          `isEdit${QueryOperator.Equal}${entity.isEdit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasAc ?
          `hasAc${QueryOperator.Equal}${entity.hasAc}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.amountContract ?
          `amountContract${QueryOperator.Contain}${entity.amountContract}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.weekday ?
          `weekday${QueryOperator.Equal}${entity.weekday}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isHoliday ?
          `isHoliday${QueryOperator.Equal}${entity.isHoliday}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockInShift ?
          `clockInShift${QueryOperator.Contain}${entity.clockInShift}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockOutShift ?
          `clockOutShift${QueryOperator.Contain}${entity.clockOutShift}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockOutShiftLunch ?
          `clockOutShiftLunch${QueryOperator.Contain}${entity.clockOutShiftLunch}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockInShiftLunch ?
          `clockInShiftLunch${QueryOperator.Contain}${entity.clockInShiftLunch}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockInToleranceShift ?
          `clockInToleranceShift${QueryOperator.Contain}${entity.clockInToleranceShift}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.clockOutToleranceShift ?
          `clockOutToleranceShift${QueryOperator.Contain}${entity.clockOutToleranceShift}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isNoentry ?
          `isNoentry${QueryOperator.Equal}${entity.isNoentry}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isNoexit ?
          `isNoexit${QueryOperator.Equal}${entity.isNoexit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.ordinaryHour ?
          `ordinaryHour${QueryOperator.Contain}${entity.ordinaryHour}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isAbsence ?
          `isAbsence${QueryOperator.Equal}${entity.isAbsence}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isDelay ?
          `isDelay${QueryOperator.Equal}${entity.isDelay}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.delayMin ?
          `delayMin${QueryOperator.Contain}${entity.delayMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isLeave ?
          `isLeave${QueryOperator.Equal}${entity.isLeave}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isUnpaidLeave ?
          `isUnpaidLeave${QueryOperator.Equal}${entity.isUnpaidLeave}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isPaidLeave ?
          `isPaidLeave${QueryOperator.Equal}${entity.isPaidLeave}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isPermit ?
          `isPermit${QueryOperator.Equal}${entity.isPermit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.permitMin ?
          `permitMin${QueryOperator.Contain}${entity.permitMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.jpermitMin ?
          `jpermitMin${QueryOperator.Contain}${entity.jpermitMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isMedicalLeave ?
          `isMedicalLeave${QueryOperator.Equal}${entity.isMedicalLeave}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isVacation ?
          `isVacation${QueryOperator.Equal}${entity.isVacation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isSubsidy ?
          `isSubsidy${QueryOperator.Equal}${entity.isSubsidy}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isSanction ?
          `isSanction${QueryOperator.Equal}${entity.isSanction}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isNolab ?
          `isNolab${QueryOperator.Equal}${entity.isNolab}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.nolabMin ?
          `nolabMin${QueryOperator.Contain}${entity.nolabMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isAdditionalEntry ?
          `isAdditionalEntry${QueryOperator.Contain}${entity.isAdditionalEntry}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalEntryMin ?
          `additionalEntryMin${QueryOperator.Contain}${entity.additionalEntryMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isAdditionalExit ?
          `isAdditionalExit${QueryOperator.Equal}${entity.isAdditionalExit}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalExitMin ?
          `additionalExitMin${QueryOperator.Contain}${entity.additionalExitMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCompensation ?
          `isCompensation${QueryOperator.Equal}${entity.isCompensation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compensationMin ?
          `compensationMin${QueryOperator.Contain}${entity.compensationMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalExitExec2 ?
          `additionalExitExec2${QueryOperator.Contain}${entity.additionalExitExec2}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCompAbsence ?
          `isCompAbsence${QueryOperator.Equal}${entity.isCompAbsence}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compAbsenceMin ?
          `compAbsenceMin${QueryOperator.Contain}${entity.compAbsenceMin}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compAbsenceExec ?
          `compAbsenceExec${QueryOperator.Contain}${entity.compAbsenceExec}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalEntryExec ?
          `additionalEntryExec${QueryOperator.Contain}${entity.additionalEntryExec}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalEntryExec2 ?
          `additionalEntryExec2${QueryOperator.Contain}${entity.additionalEntryExec2}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.compAbsenceBalance ?
          `compAbsenceBalance${QueryOperator.Contain}${entity.compAbsenceBalance}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.additionalExitExce ?
          `additionalExitExce${QueryOperator.Contain}${entity.additionalExitExce}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.employeeArea && entity.employeeArea.id) {
        query = query.concat(
          `employeeArea.id${QueryOperator.Equal}${entity.employeeArea.id}${QueryOperator.Split}`
        );
      }
      if (entity.payScale && entity.payScale.id) {
        query = query.concat(
          `payScale.id${QueryOperator.Equal}${entity.payScale.id}${QueryOperator.Split}`
        );
      }
      if (entity.paymentCategory && entity.paymentCategory.id) {
        query = query.concat(
          `paymentCategory.id${QueryOperator.Equal}${entity.paymentCategory.id}${QueryOperator.Split}`
        );
      }
      if (entity.costCenter && entity.costCenter.id) {
        query = query.concat(
          `costCenter.id${QueryOperator.Equal}${entity.costCenter.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeLaw && entity.employeeLaw.id) {
        query = query.concat(
          `employeeLaw.id${QueryOperator.Equal}${entity.employeeLaw.id}${QueryOperator.Split}`
        );
      }
      if (entity.jobTitle && entity.jobTitle.id) {
        query = query.concat(
          `jobTitle.id${QueryOperator.Equal}${entity.jobTitle.id}${QueryOperator.Split}`
        );
      }
      if (entity.attendanceHead) {
        query = query.concat(
           entity.attendanceHead.id ?
          `attendanceHead.id${QueryOperator.Equal}${entity.attendanceHead.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(
          entity.attendanceHead.employee && entity.attendanceHead.employee.id ?
          `attendanceHead.employee.id${QueryOperator.Equal}${entity.attendanceHead.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(
          entity.attendanceHead.fiscalYear && entity.attendanceHead.fiscalYear.id ?
          `attendanceHead.fiscalYear.id${QueryOperator.Equal}${entity.attendanceHead.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(
          entity.attendanceHead.executingUnit && entity.attendanceHead.executingUnit.id ?
          `attendanceHead.executingUnit.id${QueryOperator.Equal}${entity.attendanceHead.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
        query = query.concat(
          entity.attendanceHead.month && entity.attendanceHead.month.id ?
          `attendanceHead.month.id${QueryOperator.Equal}${entity.attendanceHead.month.id}${QueryOperator.Split}`
          : QueryOperator.Empty
        );
      }
      if (entity.shift && entity.shift.id) {
        query = query.concat(
          `shift.id${QueryOperator.Equal}${entity.shift.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeType && entity.employeeType.id) {
        query = query.concat(
          `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
        );
      }
      if (entity.ocurrence && entity.ocurrence.id) {
        query = query.concat(
          `ocurrence.id${QueryOperator.Equal}${entity.ocurrence.id}${QueryOperator.Split}`
        );
      }
      if (entity.employeeContract && entity.employeeContract.id) {
        query = query.concat(
          `employeeContract.id${QueryOperator.Equal}${entity.employeeContract.id}${QueryOperator.Split}`
        );
      }

      query = query.concat(
        this.extraSearchFields && this.extraSearchFields.clockInReduced && entity.clockIn ?
          // tslint:disable-next-line:max-line-length
          `clockIn${QueryOperator.Between}${this.extraSearchFields.clockInReduced.toISOString()}${QueryOperator.Slash}${entity.clockIn.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    this.extraSearchFields = null;

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'id');
    return this.httpParams;
  }

  updateDialingDate(key: string | number, entity: any): Observable<any> {
      // debugger;
      const url = this.rutaServidor + this.uri+'update/' + key;
      ////console.log('url ==> ' , url);
      ////console.log('entity ==> ', entity);
      this.spinnerService.showAll();
      return this.httpClient.put<any>(url, entity)
          .pipe(
              tap(response => {
                  // debugger;
                  this.convertToDate(response);
                  this.spinnerService.hideAll(); 
              })
              ,
              catchError(e=>{  
                  this.spinnerService.hideAll();
                  let newEntity : any
                  this.notificationService.smallBoxError(e.error.messages[0]); 
                    return Observable.throw(newEntity);
                })
          );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/attendance-body.service.ts